import { useRef } from 'react';
import { differenceInDays } from 'date-fns';

export const useIsTimestampWithinXDays = (timestamp: number, maxDays: number): boolean => {
	const now = useRef(Date.now());
	if (!timestamp) {
		return false;
	}
	return differenceInDays(now.current, timestamp) < maxDays;
};

export const parseAsTimestamp = (dateStr: unknown): number | undefined => {
	if (typeof dateStr !== 'string') {
		return undefined;
	}

	const date = new Date(dateStr);
	const dateTimestamp = date.getTime();
	return !Number.isNaN(dateTimestamp) ? dateTimestamp : undefined;
};
